<template>
  <div class="main">
    <!-- title -->
    <div class="subTitle">
      <el-link
        icon="el-icon-arrow-left"
        :underline="false"
        href="#/campaignPopup"
        >Campaign Popup Management</el-link
      >
    </div>
    <h3 class="title" content="edit" placement="bottom">Edit Campaign Popup</h3>
    <div class="detailContent">
      <div class="requireRmarks">*Required Fields</div>
      <el-form
        label-width="50%"
        label-position="left"
        ref="formCampaign"
        :model="formCampaign"
        :rules="formCampaignRules"
        class="formNotification"
      >
        <el-row>
          <h4>Title</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Sales Office" prop="salesOffice">
              <p>{{ $commonjs.salesOfficeMap(formCampaign.salesOffice) }}</p>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Title" prop="title">
              <el-input
                v-model="formCampaign.title"
                placeholder="Please enter"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>

        <el-row>
          <h4 style="margin-bottom: 8px">Images</h4>
          <p style="font-size: 14px; color: #4f7a96">
            Suggeset size: 924(W) x 1386(H),Ratio 8:12
          </p>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item
              label="1 image for all languages"
              prop="imageIsSame4All"
            >
              <el-switch
                v-model="formCampaign.imageIsSame4All"
                @change="handleSwitchChange"
              ></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="- English" prop="imageEn">
              <upload-image
                ref="UploadImageEn"
                :fileParams="imageEnFileParams"
                :fileList="imageEnFileList"
                @getSuccessRes="getImageEnRes"
                :limit="1"
                :accept="'image'"
              ></upload-image>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="- Japanese"
              prop="imageJp"
              :rules="{
                required: formCampaign.imageIsSame4All ? false : true,
                message: 'Image (JP) cannot be empty',
              }"
            >
              <upload-image
                ref="UploadImageJp"
                :fileParams="imageJpFileParams"
                :fileList="imageJpFileList"
                @getSuccessRes="getImageJpRes"
                :limit="1"
                :accept="'image'"
                :disabled="formCampaign.imageIsSame4All"
              ></upload-image>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item
              label="- Traditional Chinese"
              prop="imageTc"
              :rules="{
                required: formCampaign.imageIsSame4All ? false : true,
                message: 'Image (TC) cannot be empty',
              }"
            >
              <upload-image
                ref="UploadImageTc"
                :fileParams="imageTcFileParams"
                :fileList="imageTcFileList"
                @getSuccessRes="getImageTcRes"
                :limit="1"
                :accept="'image'"
                :disabled="formCampaign.imageIsSame4All"
              ></upload-image>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="- Simplified Chinese"
              prop="imageSc"
              :rules="{
                required: formCampaign.imageIsSame4All ? false : true,
                message: 'Image (SC) cannot be empty',
              }"
            >
              <upload-image
                ref="UploadImageSc"
                :fileParams="imageScFileParams"
                :fileList="imageScFileList"
                @getSuccessRes="getImageScRes"
                :limit="1"
                :accept="'image'"
                :disabled="formCampaign.imageIsSame4All"
              ></upload-image>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>
        <el-row>
          <h4>Button</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Button Type" prop="button1Type">
              <el-select
                v-model="formCampaign.button1Type"
                placeholder="Please select"
                @change="(v) => handleButtonChecking(v, '1')"
              >
                <el-option label="None" value="NONE"></el-option>
                <el-option label="Go to URL" value="URL"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50" v-if="formCampaign.button1Type != 'NONE'">
          <el-col :span="12">
            <el-form-item
              label="Button Name (EN)"
              prop="button1NameEn"
              :rules="{
                required: formCampaign.button1Type == 'NONE' ? false : true,
                message: 'Button Name (EN) cannot be empty',
              }"
            >
              <el-input
                maxlength="15"
                placeholder="Please enter"
                v-model="formCampaign.button1NameEn"
                :disabled="formCampaign.button1Type == 'NONE'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="Button Name (JP)"
              prop="button1NameJp"
              :rules="{
                required: formCampaign.button1Type == 'NONE' ? false : true,
                message: 'Button Name (JP) cannot be empty',
              }"
            >
              <el-input
                maxlength="15"
                placeholder="Please enter"
                v-model="formCampaign.button1NameJp"
                :disabled="formCampaign.button1Type == 'NONE'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50" v-if="formCampaign.button1Type != 'NONE'">
          <el-col :span="12">
            <el-form-item
              label="Button Name (TC)"
              prop="button1NameTc"
              :rules="{
                required: formCampaign.button1Type == 'NONE' ? false : true,
                message: 'Button Name (TC) cannot be empty',
              }"
            >
              <el-input
                maxlength="15"
                placeholder="Please enter"
                v-model="formCampaign.button1NameTc"
                :disabled="formCampaign.button1Type == 'NONE'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="Button Name (SC)"
              prop="button1NameSc"
              :rules="{
                required: formCampaign.button1Type == 'NONE' ? false : true,
                message: 'Button Name (SC) cannot be empty',
              }"
            >
              <el-input
                maxlength="15"
                placeholder="Please enter"
                v-model="formCampaign.button1NameSc"
                :disabled="formCampaign.button1Type == 'NONE'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50" v-if="formCampaign.button1Type == 'URL'">
          <el-col :span="12">
            <el-form-item
              label="URL (EN)"
              prop="button1URLEn"
              :rules="{
                required: formCampaign.button1Type == 'URL' ? true : false,
                message: 'URL (EN) cannot be empty',
              }"
            >
              <el-input
                placeholder="Please enter"
                v-model="formCampaign.button1URLEn"
                :disabled="formCampaign.button1Type !== 'URL'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="URL (JP)"
              prop="button1URLJp"
              :rules="{
                required: formCampaign.button1Type == 'URL' ? true : false,
                message: 'URL (JP) cannot be empty',
              }"
            >
              <el-input
                placeholder="Please enter"
                v-model="formCampaign.button1URLJp"
                :disabled="formCampaign.button1Type !== 'URL'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="50" v-if="formCampaign.button1Type == 'URL'">
          <el-col :span="12">
            <el-form-item
              label="URL (TC)"
              prop="button1URLTc"
              :rules="{
                required: formCampaign.button1Type == 'URL' ? true : false,
                message: 'URL (TC) cannot be empty',
              }"
            >
              <el-input
                placeholder="Please enter"
                v-model="formCampaign.button1URLTc"
                :disabled="formCampaign.button1Type !== 'URL'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="URL (SC)"
              prop="button1URLSc"
              :rules="{
                required: formCampaign.button1Type == 'URL' ? true : false,
                message: 'URL (SC) cannot be empty',
              }"
            >
              <el-input
                placeholder="Please enter"
                v-model="formCampaign.button1URLSc"
                :disabled="formCampaign.button1Type !== 'URL'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider></el-divider>

        <el-row>
          <h4>Status</h4>
        </el-row>
        <el-row :gutter="50">
          <el-col :span="12">
            <el-form-item label="Post Online" prop="postOnline">
              <el-switch v-model="formCampaign.postOnline"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Last update by" prop="updateBy">
              <p>{{ formCampaign.updateBy }}</p>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <el-row style="padding: 25px 0" type="flex" justify="end" :gutter="20">
      <el-col
        :span="4"
        v-if="
          formCampaign.status != 'REVOKED_PENDING' &&
          formCampaign.status != 'REVOKED_DELIVERED'
        "
      >
        <el-button v-if="showSave" class="reset" style="width: 100%" @click="handleCancel"
          >Cancel</el-button
        >
      </el-col>
      <el-col
        :span="4"
        v-if="
          formCampaign.status != 'REVOKED_PENDING' &&
          formCampaign.status != 'REVOKED_DELIVERED'
        "
      >
        <el-button
          v-if="showSave"
          type="primary"
          style="width: 100%"
          @click="handleSave"
          >Save</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { campaignDetail, campaignUpdate } from "@/request/api";
import UploadImage from "@/components/common/upload/Image";
export default {
  name: "editCampaign",
  data() {
    return {
      formCampaignRules: {
        title: [{ required: true, message: "Title cannot be empty" }],
        imageEn: [{ required: true, message: "Image (EN) cannot be empty" }],
      },
      formCampaign: {
        title: "",
        imageEn: "",
        imageJp: "",
        imageTc: "",
        imageSc: "",
        imageIsSame4All: false,
        button1Type: "NONE",
        button1IdName: "",
        button1NameEn: "",
        button1NameJp: "",
        button1NameTc: "",
        button1NameSc: "",
        button1URLEn: "",
        button1URLJp: "",
        button1URLTc: "",
        button1URLSc: "",
        updateBy: "",
        postOnline: false,
        salesOffice: "",
      },
      tableData: [],
      total: 0,
      currentSize: 10,
      currentPage: 1,
      imageEnFileParams: { action: "/upload/blob/POPUP_IMAGE" },
      imageEnFileList: [],
      imageJpFileParams: { action: "/upload/blob/POPUP_IMAGE" },
      imageJpFileList: [],
      imageTcFileParams: { action: "/upload/blob/POPUP_IMAGE" },
      imageTcFileList: [],
      imageScFileParams: { action: "/upload/blob/POPUP_IMAGE" },
      imageScFileList: [],
      showSave: true,
    };
  },
  components: {
    "upload-image": UploadImage,
  },
  methods: {
    getDetail() {
      campaignDetail(this.$route.params.id).then((res) => {
        console.log(res);
        let detail = res.data.payload;
        this.formCampaign.salesOffice = detail.salesOffice;
        this.formCampaign.title = detail.title;
        this.formCampaign.button1Type = detail.buttonType;
        this.formCampaign.updateBy =
          detail.updatedByName && detail.updatedAt
            ? detail.updatedByName +
              ", " +
              this.$commonjs.paramFormatDate(detail.updatedAt)
            : "-";
        this.formCampaign.postOnline = detail.postOnline;
        this.formCampaign.imageIsSame4All = detail.useGlobalLanguage;

        this.imageEnFileList = [];
        this.imageJpFileList = [];
        this.imageTcFileList = [];
        this.imageScFileList = [];

        if (detail.images) {
          if (detail.images.EN) {
            let obj = {
              name: detail.images.EN.fileName,
              url: detail.images.EN.filePath,
              fileId: detail.images.EN.fileId,
            };
            this.imageEnFileList.push(obj);
            this.formCampaign.imageEn = detail.images.EN.fileId;
          }
          if (detail.images.JA) {
            let obj = {
              name: detail.images.JA.fileName,
              url: detail.images.JA.filePath,
              fileId: detail.images.JA.fileId,
            };
            this.imageJpFileList.push(obj);
            this.formCampaign.imageJp = detail.images.JA.fileId;
          }
          if (detail.images.ZH_HK) {
            let obj = {
              name: detail.images.ZH_HK.fileName,
              url: detail.images.ZH_HK.filePath,
              fileId: detail.images.ZH_HK.fileId,
            };
            this.imageTcFileList.push(obj);
            this.formCampaign.imageTc = detail.images.ZH_HK.fileId;
          }
          if (detail.images.ZH_CN) {
            let obj = {
              name: detail.images.ZH_CN.fileName,
              url: detail.images.ZH_CN.filePath,
              fileId: detail.images.ZH_CN.fileId,
            };
            this.imageScFileList.push(obj);
            this.formCampaign.imageSc = detail.images.ZH_CN.fileId;
          }
        }
        if (this.formCampaign.button1Type == "URL") {
          this.formCampaign.button1NameEn = detail.buttons.EN.name;
          this.formCampaign.button1NameJp = detail.buttons.JA.name;
          this.formCampaign.button1NameTc = detail.buttons.ZH_HK.name;
          this.formCampaign.button1NameSc = detail.buttons.ZH_CN.name;
          this.formCampaign.button1URLEn = detail.buttons.EN.url;
          this.formCampaign.button1URLJp = detail.buttons.JA.url;
          this.formCampaign.button1URLTc = detail.buttons.ZH_HK.url;
          this.formCampaign.button1URLSc = detail.buttons.ZH_CN.url;
        }
      });
    },
    handleCancel() {
      this.$router.push("/campaignPopup");
    },
    handleSave() {
      console.log(this.formCampaign);
      this.$refs.formCampaign.validate((valid) => {
        if (valid) {
          let params = {
            useGlobalLanguage: this.formCampaign.imageIsSame4All,
            buttonType: this.formCampaign.button1Type,
            buttons: {},
            imageIds: {
              EN: this.formCampaign.imageEn,
            },
            title: this.formCampaign.title,
            postOnline: this.formCampaign.postOnline,
          };
          if (!this.formCampaign.imageIsSame4All) {
            params.imageIds["JA"] = this.formCampaign.imageJp;
            params.imageIds["ZH_HK"] = this.formCampaign.imageTc;
            params.imageIds["ZH_CN"] = this.formCampaign.imageSc;
          }
          if (this.formCampaign.button1Type == "URL") {
            params["buttons"]["EN"] = {};
            params["buttons"]["JA"] = {};
            params["buttons"]["ZH_HK"] = {};
            params["buttons"]["ZH_CN"] = {};
            params["buttons"]["EN"]["name"] = this.formCampaign.button1NameEn;
            params["buttons"]["JA"]["name"] = this.formCampaign.button1NameJp;
            params["buttons"]["ZH_HK"]["name"] =
              this.formCampaign.button1NameTc;
            params["buttons"]["ZH_CN"]["name"] =
              this.formCampaign.button1NameSc;
            params["buttons"]["EN"]["url"] = this.formCampaign.button1URLEn;
            params["buttons"]["JA"]["url"] = this.formCampaign.button1URLJp;
            params["buttons"]["ZH_HK"]["url"] = this.formCampaign.button1URLTc;
            params["buttons"]["ZH_CN"]["url"] = this.formCampaign.button1URLSc;
          }

          console.log(params);
          campaignUpdate(this.$route.params.id, params).then((res) => {
            console.log(res);
            if (res.data.status == "00") {
              this.$message.success("The changes have been saved");
              this.getDetail();
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    getImageEnRes(res) {
      console.log("ImageEn file list===", res);
      this.formCampaign.imageEn = "";
      res.forEach((item) => {
        if (item.response) {
          this.formCampaign.imageEn = item.response.payload.fileId;
        } else if (item.fileId) {
          this.formCampaign.imageEn = item.fileId;
        } else {
          this.formCampaign.imageEn = "null";
        }
      });
      console.log("this.formCampaign.imageEn ===", this.formCampaign.imageEn);
    },
    getImageJpRes(res) {
      console.log("ImageJp file list===", res);
      this.formCampaign.imageJp = "";
      res.forEach((item) => {
        if (item.response) {
          this.formCampaign.imageJp = item.response.payload.fileId;
        } else if (item.fileId) {
          this.formCampaign.imageJp = item.fileId;
        } else {
          this.formCampaign.imageJp = "null";
        }
      });
      console.log("this.formCampaign.imageJp ===", this.formCampaign.imageJp);
    },
    getImageTcRes(res) {
      console.log("ImageTc file list===", res);
      this.formCampaign.imageTc = "";
      res.forEach((item) => {
        if (item.response) {
          this.formCampaign.imageTc = item.response.payload.fileId;
        } else if (item.fileId) {
          this.formCampaign.imageTc = item.fileId;
        } else {
          this.formCampaign.imageTc = "null";
        }
      });
      console.log("this.formCampaign.imageTc ===", this.formCampaign.imageTc);
    },
    getImageScRes(res) {
      console.log("ImageSc file list===", res);
      this.formCampaign.imageSc = "";
      res.forEach((item) => {
        if (item.response) {
          this.formCampaign.imageSc = item.response.payload.fileId;
        } else if (item.fileId) {
          this.formCampaign.imageSc = item.fileId;
        } else {
          this.formCampaign.imageSc = "null";
        }
      });
      console.log("this.formCampaign.imageSc ===", this.formCampaign.imageSc);
    },
    handleButtonChecking(v, buttonNo) {
      if (v == "NONE")
        this.$refs.formCampaign.clearValidate([
          "button" + buttonNo + "IdName",
          "button" + buttonNo + "NameEn",
          "button" + buttonNo + "NameJp",
          "button" + buttonNo + "NameTc",
          "button" + buttonNo + "NameSc",
          "button" + buttonNo + "URLEn",
          "button" + buttonNo + "URLJp",
          "button" + buttonNo + "URLTc",
          "button" + buttonNo + "URLSc",
        ]);
    },
    handleSwitchChange(v) {
      if (v) {
        this.$refs.formCampaign.clearValidate([
          "imageJp",
          "imageTc",
          "imageSc",
        ]);
      }
    },
    showBtn(val) {
      console.log(this.$store.state.permissions);
      var permissions = this.$store.state.permissions.filter(
        (item) => item == val
      );
      if (!permissions[0]) {
        this.showSave = false;
      }
    },
  },
  created: function () {
    this.getDetail();
    this.showBtn("CAMPAIGN_WRITE");
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
</style>




// WEBPACK FOOTER //
// src/components/notification/editCampaign.vue